import { Loader } from 'component-library';
import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { usePathSet } from '@/hooks/usePathSet';

import { useAuth } from '../../../../lib/auth';

export const SkipLoggedInUser: React.FC<PropsWithChildren> = ({ children }) => {
  const { isBooted, isSignedIn } = useAuth();

  if (!isBooted) return <Loader />;

  if (isSignedIn) {
    // NOTE: It should basically not be possible that the user is undefined when isSignedIn is true.
    // NOTE: Those states should be coupled and typescript should be able to infer that.
    // NOTE: This will be tackled in MVP-1158
    return <Redirect />;
  }

  return <>{children}</>;
};

const Redirect: React.FC = () => {
  const paths = usePathSet();
  return <Navigate to={paths.dashboard} replace />;
};
